"use client";

import { ChangeEvent } from "react";
import Button from "../common/button";
import ProgressBar from "../common/progress-bar";
import LottieAnimation from "../common/animations";
import { CaretRight, Upload } from "../../icons";

const ProfilePicComp = ({
  userImage,
  setUserImage,
  onSubmit,
  isLoading = true,
  defaultUserImage,
}: any) => {
  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setUserImage(reader.result);
          event.target.value = "";
        };
        reader.readAsDataURL(file);
      }
    }
  };

  const handleDelete = () => {
    setUserImage(defaultUserImage.current);
  };

  return (
    <div className="h-full flex flex-col justify-between">
      <div>
        <div className="flex items-center flow-root ">
          <div className="w-32 md:mb-10 mb-6 float-left">
            <div
              className="cursor-pointer mb-3 "
              onClick={() => {
                window.history.back();
              }}
            >
              <div className="rotate-180 transform origin-left ml-5">
                <CaretRight />
              </div>
            </div>
            <LottieAnimation lottieUrl="/animation/Logo.lottie" height="40px" />
          </div>

          <div className="mt-12 ml-4 w-1/5 float-right">
            <ProgressBar currentStep={2} totalSteps={5} />
          </div>
        </div>
        <div className="text-2.8xl text-white leading-10 font-bold mb-2">
          Upload Profile Picture
        </div>
        <div className="text-2.8xl text-gray-200 leading-1 text-md mb-4">
          Personalise your 1% experience. Studies say your profile is more
          likely to be noticed with a picture.
        </div>
        <div className="bg-[#262626] py-6 rounded-md flow-root font-bold">
          <div className="w-24 h-24 rounded-full bg-white mx-auto overflow-hidden">
            {userImage && (
              <img src={userImage} className="w-full h-full object-fill" />
            )}
          </div>
          <div
            className={`flex flex-row mt-6 items-center px-6 ${userImage !== defaultUserImage.current ? "justify-between" : "justify-center"}`}
          >
            {userImage != defaultUserImage.current && (
              <div
                className="cursor-pointer text-red-500 float-left mr-2"
                onClick={handleDelete}
              >
                Delete
              </div>
            )}
            <div className="flex flex-row items-center cursor-pointer">
              {userImage === defaultUserImage.current && (
                <Upload width={24} height={24} />
              )}
              {userImage === defaultUserImage.current ? (
                <div className="ml-2 text-[#999]">Upload Picture</div>
              ) : (
                <div className="ml-2 text-[#007AFF]">Reupload Picture</div>
              )}

              <input
                type="file"
                className="absolute top-0 ledt-0 w-full h-full cursor-pointer opacity-0"
                onChange={handleFileChange}
                accept=".jpg, .jpeg, .png"
              />
            </div>
          </div>
        </div>
      </div>
      <div>
        <Button
          isSubmitting={isLoading}
          onClick={onSubmit}
          customClasses="w-full mb-5 rounded-xl"
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default ProfilePicComp;
